<template>
    <div class="customer-page" :class="{ compact }">

        <!-- 顶部图片区域 -->
        <section class="page-hero" :class="{'no-header-image': !config.headerImageUrl}">
            <img v-if="config.headerImageUrl"
                 :src="config.headerImageUrl"
                 :alt="`${storeDisplayName || merchantDisplayName}头图`"
                 class="header-image"
            />

            <div class="hero-overlay"/>

            <div class="hero-identity">
                <div style="display: flex;align-items: center;gap: 5px">
                    <img src="@/asstes/img_1.png" style="width: 16px;filter: brightness(0) invert(1);" alt="爆店卡"/>
                    <span style="font-size: 15px;font-weight: bold">种草卡 & {{ merchantDisplayName }}</span>
                </div>
            </div>

            <div class="hero-promo">
                <!--                 <span style="display: block;font-size: 20px;;font-weight: bold">-->
                <!--                        <Icon name="location"/>-->

                <!--                        {{ merchantDisplayName }}-->
                <!--                 </span>-->
                <span style="margin-top: 5px;font-size: 14px">参与商家活动种草 · 领取优质好礼！</span>
            </div>

            <div v-if="config.headerPlaceholder && !config.headerImageUrl"
                 class="header-placeholder">
                <a-icon type="picture"/>
                <span>{{ config.headerPlaceholder }}</span>
            </div>

        </section>


        <section class="page-content">


            <van-notice-bar
                    v-if="showNotice"
                    left-icon="volume"
                    :text="noticeText"
                    class="page-notice"
            />

            <button v-if="featuredItem"
                    type="button"
                    class="featured-option-card"
                    :class="{disabled: !featuredItem.enabled}"
                    @click="handleItem(featuredItem)"
            >
                <span class="featured-option-media">
                    <img v-if="itemImageFor(featuredItem)"
                         :src="itemImageFor(featuredItem)"
                         class="featured-option-image"
                    />
                    <span v-else class="option-icon" :class="featuredItem.color || 'blue'">
                        <a-icon :type="featuredItem.icon || 'appstore'"/>
                    </span>
                </span>
                <span class="featured-option-content">
                    <strong>{{ featuredItem.title }}</strong>
                    <small>{{ itemDescription(featuredItem) }}</small>
                    <span class="featured-option-action">立即参与 <a-icon type="right"/></span>
                </span>
            </button>


            <div v-if="!featuredItem && regularItems.length === 0" class="empty-state">
                <a-icon type="appstore"/>
                <strong>
                    功能正在准备中
                </strong>
                <span>
                    商户暂未开放服务卡片
                </span>
            </div>

            <section v-if="regularItems.length" class="option-list-section">
                <div class="option-grid">

                    <button v-for="item in regularItems"
                            :key="item.id"
                            class="option-card"
                            :class="{ disabled: !item.enabled }"
                            type="button"
                            @click="handleItem(item)">

                        <img v-if="itemImageFor(item)"
                             :src="itemImageFor(item)"
                             class="option-icon-image"
                        />


                        <span v-else
                              class="option-icon"
                              :class="item.color || 'blue'">
                            <a-icon :type="item.icon || 'appstore'"/>
                        </span>

                        <strong class="option-title">
                            {{ item.title }}
                        </strong>

                        <small class="option-description">
                            {{ itemDescription(item) }}
                        </small>

                    </button>
                </div>
            </section>

            <footer class="technology-support">
                <button type="button"
                        class="technology-support-link"
                        aria-label="打开爆店卡小程序"
                        @click="openMiniProgramClaim">
                    <img src="@/asstes/logo2.png" alt="爆店卡"/>
                </button>

                <span @click="openMiniProgramClaim" style="margin-top: 5px">免费领取种草卡</span>
            </footer>

        </section>

    </div>
</template>


<script>

import {NoticeBar, Icon} from 'vant';

import 'vant/lib/notice-bar/style';


import douyinIcon from '../../asstes/icon/douyin.svg';
import xiaohongshuIcon from '../../asstes/icon/xiaohongshu.svg';
import shipinhaoIcon from '../../asstes/icon/shipinhao.svg';
import meituanIcon from '../../asstes/icon/meituan.svg';
import dianpingIcon from '../../asstes/icon/dazhongdianpin.svg';
import gaodeIcon from '../../asstes/icon/gaode.svg';
import wifiIcon from '../../asstes/icon/WIFI.svg';
import weixinIcon from '../../asstes/icon/weixin.svg';
import wifi from '@/asstes/icon/WIFI.svg'


export default {

    name: 'H5PagePreview',


    components: {
        VanNoticeBar: NoticeBar,
        Icon
    },


    props: {


        config: {
            type: Object,
            required: true
        },


        compact: {
            type: Boolean,
            default: false
        },


        showDisabled: {
            type: Boolean,
            default: false
        },


        interactive: {
            type: Boolean,
            default: true
        }

    },


    computed: {


        merchantDisplayName() {

            return (
                this.config.merchantName || ''
            ).trim() || '商户服务';

        },


        storeDisplayName() {

            return (
                this.config.storeName
            ).trim();

        },


        noticeText() {

            return (
                this.config.noticeText || ''
            ).trim();

        },


        showNotice() {

            return Boolean(
                this.config.noticeEnabled &&
                this.noticeText
            );

        },


        featuredItem() {
            const groups = this.config.groups || [];
            for (const group of groups) {
                const item = (group.items || []).find(candidate => (
                    candidate.featured && (this.showDisabled || candidate.enabled)
                ));
                if (item) return item;
            }
            return null;
        },


        regularItems() {
            return (this.config.groups || []).reduce((items, group) => (
                items.concat((group.items || []).filter(item => (
                    !item.featured && (this.showDisabled || item.enabled)
                )))
            ), []).sort((left, right) => (
                (Number.isFinite(left.sortOrder) ? left.sortOrder : Number.MAX_SAFE_INTEGER)
                - (Number.isFinite(right.sortOrder) ? right.sortOrder : Number.MAX_SAFE_INTEGER)
            ));
        }


    },


    methods: {
        itemDescription(item) {
            if ((item.description || '').trim()) return item.description.trim();
            if (['DOUYIN_PUBLISH', 'WECHAT_CHANNEL_PUBLISH'].includes(item.itemType)) {
                return '快速发布';
            }
            const linkDescriptions = {
                DOUYIN_PROFILE: '关注抖音赠好礼',
                XIAOHONGSHU_PROFILE: '关注小红书赠好礼',
                WECHAT_CHANNEL_PROFILE: '关注视频号赠好礼'
            };
            if (linkDescriptions[item.itemType]) return linkDescriptions[item.itemType];
            if (['DOUYIN_REVIEW', 'MEITUAN_REVIEW', 'DIANPING_REVIEW', 'GAODE_REVIEW'].includes(item.itemType)) {
                return 'AI写文案，一键好评';
            }
            if (item.itemType === 'XIAOHONGSHU_PLANTING') return '发布种草笔记';
            if (['DOUYIN_GROUP_BUY', 'MEITUAN_GROUP_BUY', 'DIANPING_GROUP_BUY'].includes(item.itemType)) {
                return '优惠团购，点击查看';
            }
            if (item.itemType === 'STORE_WIFI') return '连接当前门店 Wi-Fi';
            if (item.itemType === 'STORE_CONTACT') return '长按二维码添加店长微信';
            return '点击查看';
        },


        itemImage(itemType) {

            return {

                DOUYIN_PROFILE: douyinIcon,
                DOUYIN_PUBLISH: douyinIcon,
                DOUYIN_REVIEW: douyinIcon,
                DOUYIN_GROUP_BUY: douyinIcon,


                XIAOHONGSHU_PROFILE: xiaohongshuIcon,
                XIAOHONGSHU_PLANTING: xiaohongshuIcon,


                WECHAT_CHANNEL_VIDEO: shipinhaoIcon,
                WECHAT_CHANNEL_PUBLISH: shipinhaoIcon,
                WECHAT_CHANNEL_PROFILE: shipinhaoIcon,


                MEITUAN_REVIEW: meituanIcon,
                MEITUAN_GROUP_BUY: meituanIcon,


                DIANPING_REVIEW: dianpingIcon,
                DIANPING_GROUP_BUY: dianpingIcon,
                GAODE_REVIEW: gaodeIcon,
                STORE_WIFI: wifiIcon,
                STORE_CONTACT: weixinIcon


            }[itemType] || '';

        },

        itemImageFor(item) {
            return String((item || {}).iconUrl || '').trim()
                || this.itemImage((item || {}).itemType);
        },


        handleItem(item) {

            if (
                !this.interactive ||
                !item.enabled
            ) {
                return;
            }


            this.$emit(
                'action',
                item
            );

        },


        openMiniProgramClaim() {

            if (!this.interactive) return;
            this.$emit('open-mini-program-claim');

        }


    }


};


</script>


<style scoped>

.customer-page {

    position: relative;

    display: flex;

    flex-direction: column;

    min-height: 100vh;


    font-family: -apple-system,
    BlinkMacSystemFont,
    "Segoe UI",
    "PingFang SC",
    sans-serif;


    background: #fff;

}


/* 顶部图片 */

.page-hero {
    position: relative;
    height: 200px;
    overflow: hidden;
    color: #fff;
    background: linear-gradient(
            135deg,
            #8fd3f4,
            #c58cff
    );
}


.header-image {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
}


.hero-overlay {
    position: absolute;
    inset: 0;
    background: linear-gradient(
            180deg,
            rgba(0, 0, 0, .48) 0,
            rgba(0, 0, 0, .08) 45%,
            rgba(0, 0, 0, .38) 100%
    );

}


.hero-identity {
    position: absolute;
    top: 20px;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    align-items: center;
    justify-content: space-between;
    z-index: 1;
    width: 90%;
    text-shadow: 0 1px 4px rgba(0, 0, 0, .45);
}

.hero-identity strong,
.hero-identity span {

    overflow: hidden;

    text-overflow: ellipsis;

    white-space: nowrap;

}


.hero-promo {

    position: absolute;

    bottom: 30px;

    left: 16px;

    z-index: 1;

    display: flex;

    max-width: calc(100% - 32px);

    flex-direction: column;

    gap: 2px;

    text-shadow: 0 2px 6px rgba(0, 0, 0, .5);

}


.hero-promo strong {

    font-size: 20px;

    line-height: 1.3;

    letter-spacing: 1px;

}


.hero-promo span {

    color: rgba(255, 255, 255, .92);

    font-size: 13px;

    line-height: 1.5;

}


.hero-identity strong {

    font-size: 18px;

    line-height: 1.35;

}


.hero-identity span {

    color: rgba(255, 255, 255, .9);

    font-size: 13px;

    line-height: 1.4;

}


.header-placeholder {


    position: absolute;

    inset: 0;

    display: flex;

    align-items: center;

    justify-content: center;

    flex-direction: column;

    gap: 8px;

    color: rgba(255, 255, 255, .8);

    font-size: 12px;


}


/* 主体 */

.page-content {

    margin-top: -20px;
    position: relative;
    display: flex;
    flex-direction: column;
    flex: 1;

    z-index: 2;
    padding: 18px 14px 30px;
    border-radius: 20px 20px 0 0;
    background: #fff;

}


/* 门店卡片 */

.store-card {


    display: flex;

    align-items: center;


    padding: 16px;


    margin-bottom: 16px;


    border-radius: 10px;


    background: #fff;


    box-shadow: 0 10px 25px rgba(80, 60, 120, .12);


}


.store-avatar {


    display: flex;


    align-items: center;


    justify-content: center;


    width: 48px;


    height: 48px;


    flex-shrink: 0;


    border-radius: 16px;


    color: #fff;


    font-size: 22px;


    background: linear-gradient(
            135deg,
            #ff9fcf,
            #7db7ff
    );


}


.store-info {


    display: flex;


    flex-direction: column;


    flex: 1;


    margin-left: 12px;


}


.store-info strong {


    color: #222;


    font-size: 16px;


    font-weight: 700;


}


.store-info span {


    margin-top: 4px;


    color: #8b8b8b;


    font-size: 12px;


}


.store-status {


    padding: 5px 12px;


    border-radius: 20px;


    color: #16a36a;


    background: #eafff4;


    font-size: 12px;


}


/* 公告 */

.page-notice {


    margin-bottom: 16px;


    border-radius: 14px;


    overflow: hidden;


}

.featured-option-card {
    display: flex;
    width: 100%;
    min-height: 120px;
    align-items: stretch;
    gap: 14px;
    margin-bottom: 20px;
    padding: 14px;
    border: 0;
    border-radius: 16px;
    color: inherit;
    background: rgba(206, 205, 205, 0.4);;
    cursor: pointer;
    text-align: left;
}

.featured-option-card.disabled {
    opacity: .45;
}

.featured-option-media {
    display: grid;
    width: 82px;
    flex: 0 0 82px;
    place-items: center;
    border-radius: 14px;
    background: #fff;
}

.featured-option-image {
    width: 62px;
    height: 62px;
    object-fit: contain;
}

.featured-option-media .option-icon {
    width: 62px;
    height: 62px;
    font-size: 25px;
}

.featured-option-content {
    display: flex;
    min-width: 0;
    flex: 1;
    flex-direction: column;
    padding-top: 2px;
}

.featured-option-content strong,
.featured-option-content small {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.featured-option-content strong {
    color: #202939;
    font-size: 17px;
    line-height: 1.5;
}

.featured-option-content small {
    margin-top: 3px;
    color: #7b8492;
    font-size: 12px;
}

.featured-option-action {
    display: flex;
    height: 34px;
    align-items: center;
    justify-content: center;
    gap: 5px;
    margin-top: auto;
    border-radius: 8px;
    color: #202939;
    background: #fff;
    font-size: 13px;
    font-weight: 600;
}


/* 分组 */

.option-group + .option-group {


    margin-top: 20px;


}


.group-heading {


    display: flex;

    align-items: center;

    justify-content: center;

    gap: 10px;

    margin-bottom: 14px;


}


.group-heading::before,
.group-heading::after {

    width: 34px;

    height: 1px;

    content: '';

    background: #c7ced8;


}


.group-title {


    padding: 2px 0;


    color: #344054;


    font-size: 13px;


    font-weight: 700;


    letter-spacing: .5px;


}


/* 功能区域 */

.option-grid {


    display: grid;


    grid-template-columns:

    repeat(2, minmax(0, 1fr));


    gap: 8px;


}


.option-card {


    display: flex;


    min-width: 0;

    min-height: 100px;

    align-items: flex-start;


    justify-content: flex-start;


    flex-direction: column;


    padding: 16px;


    border: none;


    border-radius: 10px;


    cursor: pointer;


    background: rgba(206, 205, 205, 0.4);


}


.option-card.disabled {


    opacity: .45;


}


/* 图标 */

.option-icon {


    display: flex;


    align-items: center;


    justify-content: center;


    width: 40px;


    height: 40px;


    border-radius: 12px;


    font-size: 18px;


}


.option-icon-image {


    width: 42px;


    height: 42px;


    object-fit: contain;


}


/* 图标颜色 */

.option-icon.blue {


    color: #2878df;

    background: #e9f2ff;


}


.option-icon.green {


    color: #21a67a;

    background: #e6f8f1;


}


.option-icon.orange {


    color: #ee8a36;

    background: #fff1e5;


}


.option-icon.purple {


    color: #7c5ce4;

    background: #f1edff;


}


.option-icon.red {


    color: #e65353;

    background: #ffebeb;


}


.option-title {


    margin-top: 10px;


    max-width: 100%;


    overflow: hidden;


    color: #222c3e;


    font-size: 15px;


    font-weight: 600;


    text-overflow: ellipsis;


    white-space: nowrap;


}


/* 空状态 */

.empty-state {


    display: flex;


    align-items: center;


    justify-content: center;


    flex-direction: column;


    min-height: 190px;


    color: #a2aaba;


}


.empty-state .anticon {


    font-size: 34px;


}


.empty-state strong {


    margin-top: 12px;


}


.technology-support {


    display: flex;


    align-items: center;


    justify-content: center;


    flex-direction: column;


    padding-top: 35px;


    color: #adb5c5;


    font-size: 10px;


    line-height: 1.7;


}

.technology-support-link {
    display: block;
    border: 0;
    background: transparent;
    cursor: pointer;
}

.technology-support-link img {
    display: block;
    width: 80px;
}


/* 手机紧凑模式 */

.customer-page.compact {


    min-height: 620px;


}


.compact .page-content {


    padding: 16px 10px 24px;
    border-radius: 14px 14px 0 0;

}


.compact .store-card {


    padding: 12px;


    border-radius: 10px;


}


.compact .option-grid {


    gap: 7px;


}

.compact .featured-option-card {
    min-height: 96px;
    gap: 10px;
    padding: 10px;
    border-radius: 12px;
}

.compact .featured-option-media {
    width: 62px;
    flex-basis: 62px;
    border-radius: 14px;
}

.compact .featured-option-image,
.compact .featured-option-media .option-icon {
    width: 46px;
    height: 46px;
}

.compact .featured-option-content strong {
    font-size: 13px;
}

.option-description {
    display: -webkit-box;
    margin-top: 4px;
    overflow: hidden;
    color: #8a929f;
    font-size: 11px;
    font-weight: 400;
    line-height: 1.45;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
}

.option-card {
    border-radius: 14px;
}

.compact .featured-option-content small {
    font-size: 10px;
}

.compact .featured-option-action {
    height: 28px;
    font-size: 11px;
}


.compact .option-card {


    min-height: 92px;


    border-radius: 14px;


}


.compact .option-title {


    margin-top: 7px;

    font-size: 11px;


}

.compact .option-description {
    font-size: 9px;
}


</style>
